// src/app/services/documentos.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Documento {
  id: number;
  tipoDocumento: string;
  sigla: string;
  cargarDigital: number;
  tipoEntidad: number;
  created: string; // o Date, según manejo
  formatos:string
}

@Injectable({
  providedIn: 'root'
})
export class DocumentosService {
   private apiUrl =  `${environment.apiUrl}/api/tiposDocumentos`; 


  constructor(private http: HttpClient) {}

  getDocumentosByTipoEntidad(tipoEntidad: number): Observable<Documento[]> {
    return this.http.get<Documento[]>(`${this.apiUrl}/tipoEntidad/${tipoEntidad}`);
  }
}
